import React from "react";
import {
  Box,
  Container,
  Divider,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import {
  contactDetails,
  footerLinks,
  posts,
  siteMeta,
} from "../../data/mockData";

const Footer = () => (
  <Box
    sx={{
      position: "relative",
      overflow: "hidden",
      color: "#fff",
      pt: { xs: 7, md: 8.5 },
      pb: 4.5,
      background:
        "linear-gradient(180deg, #0c1522 0%, #101a2b 44%, #14233a 100%)",
      "&::after": {
        content: '""',
        position: "absolute",
        inset: 0,
        background:
          "linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px)",
        backgroundSize: "88px 88px",
        opacity: 0.12,
        pointerEvents: "none",
      },
    }}
  >
    <Container>
      <Grid
        container
        spacing={{ xs: 4, md: 5 }}
        sx={{ position: "relative", zIndex: 1, width: "100%", m: 0 }}
      >
        <Grid item xs={12} lg={4} md={6}>
          <Box
            className="eyebrow"
            sx={{
              color: "#fff",
              "&::before": {
                background:
                  "linear-gradient(90deg, rgba(255,255,255,0.14), #dec095)",
              },
            }}
          >
            {siteMeta.projectName}
          </Box>
          <Typography variant="h5" sx={{ mt: 1.5, maxWidth: 420 }}>
            Mining, trade, and industrial services.
          </Typography>
          <Typography
            variant="body2"
            sx={{ mt: 2.25, color: "rgba(255,255,255,0.76)", maxWidth: 430 }}
          >
            Refwa operates across mining, petroleum services, international
            trade, construction, environmental services, heavy equipment,
            facility operations, and sustainability-related work.
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} lg={2} md={6}>
          <Typography variant="overline" sx={{ color: "primary.light" }}>
            Quick Links
          </Typography>
          <Stack spacing={1.35} sx={{ mt: 2.25 }}>
            {footerLinks.quickLinks.map((item) => (
              <Typography
                key={item.label}
                component={RouterLink}
                to={item.to}
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.72)",
                  "&:hover": { color: "#fff" },
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6} lg={3} md={6}>
          <Typography variant="overline" sx={{ color: "primary.light" }}>
            Contact
          </Typography>
          <Stack spacing={1.35} sx={{ mt: 2.25 }}>
            {contactDetails.map((item) => (
              <Box key={item.title}>
                <Typography variant="subtitle2" sx={{ color: "primary.light" }}>
                  {item.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "rgba(255,255,255,0.72)", lineHeight: 1.7 }}
                >
                  {item.value}
                </Typography>
              </Box>
            ))}
          </Stack>
        </Grid>
        <Grid item xs={12} lg={3} md={6}>
          <Typography variant="overline" sx={{ color: "primary.light" }}>
            Articles
          </Typography>
          <Stack spacing={1.35} sx={{ mt: 2.25 }}>
            {posts.slice(0, 2).map((post) => (
              <Typography
                key={post.id}
                component={RouterLink}
                to={`/articles/${post.slug}`}
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.72)",
                  lineHeight: 1.7,
                  "&:hover": { color: "#fff" },
                }}
              >
                {post.title}
              </Typography>
            ))}
          </Stack>
        </Grid>
      </Grid>

      <Divider
        sx={{
          my: { xs: 4, md: 4.5 },
          borderColor: "rgba(255,255,255,0.12)",
          position: "relative",
          zIndex: 1,
        }}
      />

      <Stack
        direction={{ xs: "column", md: "row" }}
        spacing={2}
        justifyContent="space-between"
        alignItems={{ md: "center" }}
        sx={{ position: "relative", zIndex: 1 }}
      >
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.64)" }}>
          Copyright 2026 Refwa. All rights reserved.
        </Typography>
        <Stack direction="row" spacing={2.5} flexWrap="wrap" useFlexGap>
          {footerLinks.policyLinks.map((item) => (
            <Typography
              key={item.label}
              component={RouterLink}
              to={item.to}
              variant="body2"
              sx={{
                color: "rgba(255,255,255,0.64)",
                "&:hover": { color: "#fff" },
              }}
            >
              {item.label}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </Container>
  </Box>
);

export default Footer;
